"use strict";

export default class CalendarLocalGroup {
  constructor() {
    let calendar;
    let $color_map = false;

    $(".fc-day-grid-event").off();
    $('body').on('click', '.fc-day-grid-event', function(e) {
      e.stopPropagation();
      e.preventDefault();
    });

    (function() {
      try {
        // loadCalendar();
      } catch (error) {
        console.log(error);
      }
    })();
    
    $("body").on('click', "a[href='#calendar']", function(e) {
      try {
        // loadCalendar();
      } catch (error) {
        console.warn(error);
      }
    });

    function loadCalendar() {
      console.log("load calendar");

      var calendarEl = document.getElementById(
        "local-group-calendar-placeholder"
      );
      
      if(!calendarEl) return;
      
      calendarEl.classList.add("calendar-algolia-calendar");
      calendar = new FullCalendar.Calendar(calendarEl, {
        initialView: "dayGridMonth",
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right: "dayGridMonth,dayGridWeek,timeGridDay,listMonth"
        },
        views: {
          listMonth: {
            eventContent: function(event, element) {
              //return event;
            }
          }
        },
        eventContent: function(event, element) {
          //element.addClass(event.class)
          // console.log(element);
          // console.log(event.event._def.extendedProps.field_type);
          // console.log(event.event._def.extendedProps.field_type_id);
          var $color = getColor(event.event._def.extendedProps);
          return {
            html:
              '<div class="fc-daygrid-event-dot ' +
              $color +
              '"></div><div class="fc-event-time  ' +
              $color +
              '">' +
              event.timeText +
              'm</div><div class="fc-event-title ' +
              $color +
              '">' +
              event.event._def.title +
              '</div><div class="popover"><div class="inner ' +
              $color +
              '"><div class="date"><h5>Date</h5><span class="day">' +
              event.event._def.extendedProps.field_smartdate_value +
              '</span><span class="month">' +
              event.event._def.extendedProps.field_smartdate_value_1 +
              '</span></div><div class="time"><h5>Duration</h5><span class="duration">' +
              event.event._def.extendedProps.field_smartdate_duration +
              ' minutes</span></div><div class="address"><h5>Address</h5>' +
              event.event._def.extendedProps.field_address +
              '</div><div class="description"><h5>Description</h5><p>' +
              event.event._def.extendedProps.field_short_description +
              '</p></div><div class="contact"><h5>Contact</h5>' +
              event.event._def.extendedProps.field_contact_details +
              '</div><div class="link button yellow">Find out more </div></div></div>'
          };
        }
      });
      calendar.render();

      var currentDate = calendar.getDate(),
        parsedCurrentDate = Date.parse(currentDate),
        currentMonthHasNoEvent = true,
        targetDate = parsedCurrentDate;

      var date = new Date();
      var firstDayofCurrentMonth = new Date(
        date.getFullYear(),
        date.getMonth(),
        1
      );
      var lastDayOfCurrentMonth = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0
      );

      // Pull in the National and Online events
      addLocalEventsAndWorkshop(calendar);

      calendar.getEvents();
      setTimeout(function() {
        calendar.gotoDate(targetDate);
      }, 1000);
    }

    function addLocalEventsAndWorkshop($calendar) {
      $.getJSON("/api/group/events?group_id=2") // Replace with /api/group/events?group_id=2
        .done(function($items) {
          $($items).each(function($index, $value) {
            var currentDatetime = new Date($value.field_smartdate_end_value);
            console.log(currentDatetime);
            let formattedDate =
              currentDatetime.getDate() +
              "/" +
              (currentDatetime.getMonth() + 1) +
              "/" +
              currentDatetime.getFullYear();
            $calendar.addEvent({
              title: $value.label_value,
              start: $value.field_smartdate_end_value,
              url: $value.link_url,
              extendedProps: {
                field_smartdate_value: $value.field_smartdate
                  ? formattedDate
                  : "",
                field_smartdate_value_1: $value.field_smartdate_1
                  ? $value.field_smartdate_1
                  : "",
                field_smartdate_duration: $value.field_smartdate_duration
                  ? $value.field_smartdate_duration
                  : "",
                field_address: $($value.field_address).length
                  ? $value.field_address_address_line1 +
                    "<br/>" +
                    $value.field_address_address_line2 +
                    "<br/>" +
                    $value.field_address_locality +
                    " " +
                    $value.field_address_postal_code
                  : "",
                field_short_description: $($value.field_short_description)
                  .length
                  ? $value.field_short_description_value
                  : "",
                field_contact_details: $($value.field_contact_details).value
                  ? $value.field_contact_details_value
                  : "",
                field_type_id: $($value.field_type).length
                  ? $value.field_type_target_id
                  : null
              }
            });
          });
        });
    }

    function getColor($extended_data) {
      // Need to check if this is working

      return "";
    }
  }
}
